// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"25e3da15","417":"8f1c5a71","453":"40b08185","502":"c74fb8ad","701":"289ac13a"}[chunkId] + ".chunk.js";
};